import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  ButtonIconContextual,
  SpinnerLoader,
  HelperViewContextual,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { PerformanceHistoryAccordion } from './components/PerformanceHistoryAccordion';

import {
  getPerformance,
  IDefaultProps
} from '@/modules/investments/services/investments';


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHistory',
  setup(__props) {

const router = useRouter();

const hasError = ref(false);
const isLoading = ref(true);
const historyOverview = ref<IDefaultProps[]>([]);
const updatedAt = ref('');

const isEmpty = computed(() => historyOverview.value.length === 0);

async function fetchPerformance() {
  try {
    hasError.value = false;
    isLoading.value = true;

    const data = await getPerformance();

    historyOverview.value = data.performanceHistoryOverview;
    updatedAt.value = data.updatedAt.formatted;
  } catch (e) {
    console.error(e);
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

function onBack() {
  router.back();
}

onMounted(() => {
  fetchPerformance();
});

return { __sfc: true,router, hasError, isLoading, historyOverview, updatedAt, isEmpty, fetchPerformance, onBack, NavBar, ButtonIconContextual, SpinnerLoader, HelperViewContextual, HelperViewStatus, ShowMoneyToggleButton, PerformanceHistoryAccordion }
}

})